import {useLocation} from 'react-router-dom';

import {Grid, Typography} from '@mui/material';

export const CultureComparisonPage = () => {
  const location = useLocation();
  const queryParams = location.state?.queryParams;

  return (
    <Grid container flexDirection={'column'}>
      <Typography variant='h1'>Culture Coparison</Typography>
      <Typography variant='body1'>Query Parameters: {queryParams}</Typography>
    </Grid>
  );
};
